/**
 * Created with IntelliJ IDEA.
 * User: pburst
 * Date: 02.10.12
 * Time: 12:03
 * To change this template use File | Settings | File Templates.
 */


/**
 * Names of Javascript functions called by the client in the embedding HTML page
 *
 * Documentation:
 * https://docs.google.com/a/goodgamestudios.com/spreadsheet/ccc?key=0AtXFx56d9X1adDlYcUtZc3JVdThMQ0NES0pUYlFqMHc#gid=0
 */
export class JavascriptFunctionName {
    public static ON_LOAD: string = "ggsOnLoad";
    public static ON_LOAD_COMPLETE: string = "ggsOnLoadComplete";
    public static ON_REGISTER_COMPLETE: string = "ggsOnRegisterComplete";
    public static ON_LOGIN_COMPLETE: string = "ggsOnLoginComplete";
    public static ON_LOGOUT: string = "ggsOnLogout";

    public static SET_CASH_HASH: string = "setCashHash";
    // "setLanguage" is used to change the language of the additional php-panel in SSO-networks.
    public static SET_LANGUAGE: string = "setLanguage";
    public static TRIGGER_CONVERSION_PIXEL: string = "ggsTriggerConversionPixel";

    public static REQUEST_LOGIN_KEYS: string = "requestLoginKeys";

    public static SET_SESSION_PARAMETERS: string = "setSessionParameters";

    public static REQUEST_GROUP: string = "requestGroup";

    public static RELOAD_EMBED: string = "ggsReloadEmbed";
}
